<template>
    <div>
        <v-simple-table fixed-header :height="tableHeight">
            <template v-slot:default>
                <thead>
                    <tr>
                        <th
                            v-for="col in tableHeaders"
                            :key="`th-${col.value}`"
                        >
                            {{ col.text }}
                        </th>
                        <th>
                            <!-- extra col for row actions -->
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in items" :key="`row-${item.id}`">
                        <td
                            v-for="col in tableHeaders"
                            :key="`td-${col.value}`"
                        >
                            <span v-if="col.value === 'healthCheckStatus'">
                                <device-health-icon
                                    :value="{
                                        status: item[col.value] || '',
                                        statusDate:
                                            item['healthCheckStatusDate'] || ''
                                    }"
                                >
                                </device-health-icon>
                            </span>
                            <span v-else>{{ item[col.value] }}</span>
                        </td>
                        <td v-show="!isEditing">
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        color="primary"
                                        v-on="on"
                                        @click="onOpenDeviceClick(item)"
                                    >
                                        {{ icons.viewItem }}
                                    </v-icon>
                                </template>
                                <span>Device details & actions</span>
                            </v-tooltip>
                        </td>
                        <td v-show="isEditing">
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        v-show="!item.disableRemove"
                                        x-small
                                        outlined
                                        color="accent"
                                        v-on="on"
                                        @click="onRemoveDeviceClick(item)"
                                        >Remove</v-btn
                                    >
                                </template>
                                <span>Remove device from space</span>
                            </v-tooltip>
                        </td>
                    </tr>
                    <tr v-show="!items.length">
                        <td colspan="6" class="text-center">
                            No devices added yet...
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
        <component
            :is="deviceDetailsComponent"
            :show-dialog="showDeviceDetailsDialog"
            :device-id="selectedDeviceId"
            @close-dialog="onCloseDeviceDetailsDialog"
        >
        </component>
    </div>
</template>

<script>
import { isEmpty } from '@/common/helpers';
import DeviceHealthIcon from '@/components/Fields/DeviceHealthIcon';
import DeviceDetailsDialog from '../../devices/components/DeviceDetailsDialog';

// TODO: need to refresh the parent view if device data has been updated.
export default {
    name: 'SpaceDevicesList',
    components: {
        'device-health-icon': DeviceHealthIcon,
        'device-details-dialog': DeviceDetailsDialog
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        isEditing: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            tableHeaders: [
                { text: 'Name', value: 'name' },
                { text: 'Serial Number', value: 'serialNumber' },
                { text: 'XBO Device Id', value: 'xboDeviceId' },
                { text: 'Health', value: 'healthCheckStatus' },
                { text: 'Host Mac', value: 'hostMac' }
            ],
            deviceDetailsComponent: '',
            selectedDeviceId: '',
            showDeviceDetailsDialog: false
        };
    },
    computed: {
        tableHeight() {
            if (this.$vuetify.breakpoint.mdAndUp) {
                return this.items.length > 3 ? '250px' : '150px';
            } else {
                return '';
            }
        }
    },
    methods: {
        // ======================= Events ========================
        onOpenDeviceClick(device) {
            this.openDeviceDialog(device);
        },
        onCloseDeviceDetailsDialog() {
            this.deviceDetailsComponent = '';
            this.showDeviceDetailsDialog = false;
            this.selectedDeviceId = '';
        },
        onRemoveDeviceClick(device) {
            this.$emit('remove', device);
        },
        // ======================= Others ======================
        openDeviceDialog(device) {
            if (!isEmpty(device) && !isEmpty(device.id)) {
                this.deviceDetailsComponent = 'device-details-dialog';
                this.selectedDeviceId = device.id;
                this.showDeviceDetailsDialog = true;
            }
        }
    }
};
</script>

<style lang="scss"></style>
